import { combine, withContext } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import SignOutComponent from './component'

export const SignOut = combine({
  hooks: [withContext('appStore', StoreContext)],
  transformProps: ({ appStore, ...rest }) => {
    return {
      ...rest,
      auth: appStore.auth,
    }
  },
})(SignOutComponent)
